import MenuBar from '../../USA/Component/MenuBar';
import PageBanner from '../../USA/Component/PageBanner';
import Footer from '../../USA/Component/Footer';

export default function MembershipReports() {
  return (
    <>
      <MenuBar />

      <PageBanner title="Membership Reports" />


      <section className="contact-section contact-page" style={{ marginTop: '20px' }}>
        <div className="auto-container">
          <div className="sec-title centered">
            <div className="upper-icon"></div>
            <h2>Reports</h2>
          </div>

          <div className="alert alert-info" role="alert">
            Report endpoints are not yet configured in Swagger. Once you share the report API paths and
            request parameters, I will wire the filters and tables here.
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
